<template>
<!-- component to display all the contact -->
    <section class="ftco-section" >
        <div class="container-fluid">
            <div class="row ">
                <div class="col-md-6  mb-5">
                    <h2 class="heading-section">Contact List</h2>
                </div>
            </div>
            <!--  -->
            <div class="row">
                <!--  -->
                <div class="col-md-12">
                    <div class="table-wrap">
                        <table class="table table-responsive-xl">
                        <thead>
                            <tr>
                                <th>&nbsp;</th>
                                <th>Email</th>
                                <th>username</th>
                                <th>Status</th>
                                <th>&nbsp;</th>
                            </tr>
                        </thead>
                        <!-- tbody -->
                        <tbody>
                            <tr class="alert" role="alert">
                                <td>
                                    <label class="checkbox-wrap checkbox-primary">
                                        <input type="checkbox" >
                                        <span class="checkmark"></span>
                                    </label>
                                </td>
                                <td class="d-flex align-items-center">
                                    <div class="img"></div>
                                    <div class="pl-3 email">
                                        <span>oyerinde@gamil.com</span>
                                        <span>Added: 01/03/2020</span>
                                    </div>
                                </td>
                                <td>MaxJosh</td>
                                <td class="status"><span class="active">Active</span></td>
                                <td>
                                    <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                                        <span aria-hidden="true"><i class="fa fa-close"></i></span>
                                    </button>
                                </td>
                            </tr>
                            <!-- /tr -->
                            <tr class="alert" role="alert">
                                <td>
                                    <label class="checkbox-wrap checkbox-primary">
                                        <input type="checkbox" >
                                        <span class="checkmark"></span>
                                    </label>
                                </td>
                                <td class="d-flex align-items-center">
                                    <div class="img"></div>
                                    <div class="pl-3 email">
                                        <span>oyerinde@gamil.com</span>
                                        <span>Added: 01/03/2020</span>
                                    </div>
                                </td>
                                <td>MaxJosh</td>
                                <td class="status"><span class="active">Active</span></td>
                                <td>
                                    <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                                        <span aria-hidden="true"><i class="fa fa-close"></i></span>
                                    </button>
                                </td>
                            </tr>
                            <!--  -->
                            <tr class="alert" role="alert">
                                <td>
                                    <label class="checkbox-wrap checkbox-primary">
                                        <input type="checkbox" >
                                        <span class="checkmark"></span>
                                    </label>
                                </td>
                                <td class="d-flex align-items-center">
                                    <div class="img"></div>
                                    <div class="pl-3 email">
                                        <span>oyerinde@gamil.com</span>
                                        <span>Added: 01/03/2020</span>
                                    </div>
                                </td>
                                <td>MaxJosh</td>
                                <td class="status"><span class="active">Active</span></td>
                                <td>
                                    <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                                        <span aria-hidden="true"><i class="fa fa-close"></i></span>
                                    </button>
                                </td>
                            </tr>
                            <!--  -->
                            <tr class="alert" role="alert">
                                <td>
                                    <label  class="checkbox-wrap checkbox-primary">
                                        <input type="checkbox" >
                                        <span class="checkmark"></span>
                                    </label>
                                </td>
                                <td class="d-flex align-items-center">
                                    <div class="img"></div>
                                    <div class="pl-3 email">
                                        <span>oyerinde@gamil.com</span>
                                        <span>Added: 01/03/2020</span>
                                    </div>
                                </td>
                                <td>MaxJosh</td>
                                <td class="status"><span class="active">Active</span></td>
                                <td>
                                    <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                                        <span aria-hidden="true"><i class="fa fa-close"></i></span>
                                    </button>
                                </td>
                            </tr>
                        </tbody>

                        </table>
                    </div>
                </div>
                <!-- col /end here -->
            </div>
            <!-- row end here -->
        </div>
    </section>
</template>

<script>
export default {
    data(){
        return{

        }
    }
}
</script>

<style lang="css" scoped>
    .table-wrap {
    overflow-x: scroll; 
}
  
  .table {
    min-width: 1000px !important;
    width: 100%;
    -webkit-box-shadow: 0px 5px 12px -12px rgba(0, 0, 0, 0.29);
    -moz-box-shadow: 0px 5px 12px -12px rgba(0, 0, 0, 0.29);
    box-shadow: 0px 5px 12px -12px rgba(0, 0, 0, 0.29); }
    .table thead th {
      border: none;
      padding: 30px;
      font-size: 13px;
      font-weight: 500;
       color: white;
    }

    .table thead tr {
      background: #0085A1;
      border-bottom: 4px solid #f7f7f7; 
    }
    .table tbody tr {
      margin-bottom: 10px;
      border-bottom: 4px solid #f8f9fd; 
    }
      .table tbody tr:last-child {
        border-bottom: 0; 
    }
    .table tbody th, .table tbody td {
      border: none;
      padding: 30px;
      font-size: 14px;
      background: #fff;
      vertical-align: middle; 
      }
    .table tbody td.status span {
      position: relative;
      border-radius: 30px;
      padding: 4px 10px 4px 25px; 
      }
      .table tbody td.status span:after {
        position: absolute;
        top: 9px;
        left: 10px;
        width: 10px;
        height: 10px;
        content: '';
        border-radius: 50%; 
    }
    .table tbody td.status .active {
      background: #cff6dd;
      color: #1fa750; 
    }
      .table tbody td.status .active:after {
        background: #23bd5a; 
    }
    .table tbody td.status .waiting {
      background: #fdf5dd;
      color: #cfa00c; 
    }
      .table tbody td.status .waiting:after {
        background: #f2be1d; 
    }
    .table tbody td .img {
      width: 50px;
      height: 50px;
      border-radius: 50%; 
    }
    .table tbody td .email span {
      display: block; 
    }
      .table tbody td .email span:last-child {
        font-size: 12px;
        color: rgba(0, 0, 0, 0.3); 
    }
    .table tbody td .close span {
      font-size: 12px;
      color: #dc3545; 
    }
  
  .checkbox-wrap {
    display: block;
    position: relative;
    cursor: pointer;
    font-size: 16px;
    font-weight: 500;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none; 
    
}
  
  /* Hide the browser's default checkbox */
  .checkbox-wrap input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0; 
}
  
  /* Create a custom checkbox */
  .checkmark {
    position: absolute;
    top: 0;
    left: 0; 
}
  
  /* Create the checkmark/indicator (hidden when not checked) */
  .checkmark:after {
    content: "\f0c8";
    font-family: "FontAwesome";
    position: absolute;
    color: rgba(0, 0, 0, 0.1);
    font-size: 20px;
    margin-top: -14px;
    -webkit-transition: 0.3s;
    -o-transition: 0.3s;
    transition: 0.3s; 
    }

    @media (prefers-reduced-motion: reduce) {
      .checkmark:after {
        -webkit-transition: none;
        -o-transition: none;
        transition: none; 
        } 
    }
  
  /* Show the checkmark when checked */
  .checkbox-wrap input:checked ~ .checkmark:after {
    display: block;
    content: "\f14a";
    font-family: "FontAwesome";
    color: rgba(0, 0, 0, 0.2); 
    }
  
  /* Style the checkmark/indicator */
  .checkbox-primary {
    color: #40bfc1; 
    }
    .checkbox-primary input:checked ~ .checkmark:after {
      color: #40bfc1; 
    }

 .img{
        background-image: url('../assets/images/person_1.jpg');
        background-repeat: no-repeat;
        background-size: cover;
    }
  
</style>